import { FlatList } from 'react-native';
import { Surface as SurfaceBase } from 'react-native-paper';
import { Button as ButtonPaper } from 'react-native-paper';
import styled from 'styled-components/native';

import Button from '@src/components/Button';
import FontIcon from '@src/components/FontIcon';
import Image from '@src/components/Image';
import ImageBackground from '@src/components/ImageBackground';
import Separator from '@src/components/Separator';
import { Body1, H1 } from '@src/components/Typography';
import { maxWidth, padding, windowWidth } from '@src/configuration/constants';
import { PrimeMedia, Review } from '@src/types';

const MEDIA_PREVIEW_CARD_WIDTH = windowWidth * 0.6;
const MEDIA_PREVIEW_CARD_HEIGHT = MEDIA_PREVIEW_CARD_WIDTH / 2;

export const CoverContainer = styled.View`
  border-radius: 16px;
  overflow: hidden;
  width: 128px;
  height: 185px;
`;
export const Cover = styled(ImageBackground)`
  display: inline;
  margin: 0 auto;
  height: 100%;
  width: 100%;
`;
export const Row = styled.View`
  flex-direction: row;
`;

export const Column = styled.View`
  flex-direction: column;
`;

export const CenteredColumn = styled(Column)`
  align-items: flex-start;
`;

export const CenteredRow = styled(Row)`
  justify-content: space-between;
  margin-top: 8px;
`;
export const SampleRow = styled(Row)<{ align?: string }>`
  align-items: center;
  width: 100%;
`;
export const LargeText = styled(Body1)<{
  textColor?: string;
  padding?: number;
  isBold?: boolean;
}>`
  color: ${({ theme, textColor }) =>
    textColor ? textColor : theme.colors.onAccent};
  padding-left: ${({ padding }) => (padding ? padding : 0)}px;
  font-weight: ${({ isBold }) => (isBold ? 700 : 400)};
`;
export const ContentIcon = styled(Image)`
  width: 24px;
  height: 24px;
  resize-mode: contain;
`;
export const SampleButton = styled(ButtonPaper).attrs(({ theme }) => ({
  uppercase: false,
  mode: 'outlined',
  labelStyle: {
    color: theme.colors.primary,
    fontSize: 16,
  },
}))`
  width: 45%;
  border-radius: 8px;
  border-color: ${({ theme }) => theme.colors.primary};
  border-width: 1px;
`;
export const TiltleText = styled(H1).attrs({
  dir: 'unset',
})<{ weight?: number; padding?: number; isHome?: Boolean | undefined }>`
  padding-right: ${({ padding }) => (padding ? padding : 20)}px;
  font-weight: ${({ weight }) => (weight ? weight : 400)};
`;
export const Content = styled.View`
  padding: ${padding}px;
`;

export const Star = styled(FontIcon).attrs({
  name: 'star-o',
  size: 12,
})``;

export const ReviewList = styled(FlatList as new () => FlatList<Review>).attrs(
  () => ({
    removeClippedSubviews: true,
    scrollEventThrottle: 8,
    initialNumToRender: 4,
    maxToRenderPerBatch: 4,
    keyExtractor: ({ user, date }) => user?.id + date,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingBottom: padding,
      maxWidth: maxWidth,
      width: '100%',
      alignSelf: 'center',
      marginHorizontal: 'auto',
      paddingHorizontal: padding,
    },
  })
)``;

export const MediaPreviewList = styled(
  FlatList as new () => FlatList<PrimeMedia>
).attrs(() => ({
  horizontal: true,
  removeClippedSubviews: true,
  scrollEventThrottle: 8,
  keyExtractor: ({ id }) => id,
  ItemSeparatorComponent: Separator,
  showsHorizontalScrollIndicator: false,
  contentContainerStyle: {
    paddingHorizontal: padding,
    paddingBottom: 5,
  },
}))``;

export const Surface = styled(SurfaceBase)`
  elevation: 4;
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  margin-bottom: ${padding / 2}px;
  overflow: hidden;
`;

export const MediaPreview = styled(Image)`
  width: ${MEDIA_PREVIEW_CARD_WIDTH}px;
  height: ${MEDIA_PREVIEW_CARD_HEIGHT}px;
`;

export const ReviewButton = styled(ButtonPaper).attrs(({ theme }) => ({
  mode: 'outlined',
  uppercase: false,
  labelStyle: {
    color: theme.colors.primary,
    fontSize: 16,
  },
}))`
  border-radius: 8px;
  border-color: ${({ theme }) => theme.colors.primary};
  border-width: 1px;
`;

export const ModalContainer = styled(SurfaceBase)`
  elevation: 4;
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.background};
  padding: ${padding * 2}px ${padding}px;
  overflow: hidden;
  width: 80%;
  min-height: 50%;
  align-self: center;
  justify-content: space-around;
  align-items: stretch;
`;
